

































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import parse from 'date-fns/parse'
import format from 'date-fns/format'

@Component
export default class DateInput extends Vue {
  @Ref()
  private pickerMenu!: any

  @Prop({ required: true })
  private value!: string

  @Prop({ default: 'dd.MM.YYYY' })
  private displayFormat!: string

  @Prop({ default: 'yyyy-MM-dd' })
  private modelFormat!: string

  @Prop({ default: '' })
  private name!: string

  @Prop({ default: '' })
  private rules!: string

  @Prop({ default: () => [] })
  private errors!: any[]

  private menu = false
  private model = this.formatDate(this.value)
  private displayModel = this.formatDisplayDate(this.value)

  @Watch('value')
  private valueChanged(val: string) {
    this.model = this.formatDate(val)
    this.displayModel = this.formatDisplayDate(val)
  }

  private dateSelected() {
    this.pickerMenu.save(this.model)
    this.$emit('input', this.model)
  }

  private formatDate(val: string) {
    if (val) {
      const date = parse(val, this.modelFormat, new Date())
      return format(date, this.modelFormat)
    }
    return ''
  }

  private formatDisplayDate(val: string) {
    if (val) {
      const date = parse(val, this.modelFormat, new Date())
      return format(date, this.displayFormat)
    }
    return ''
  }
}
